import * as request from "../utils/request"
import * as helper from "../utils/helper"
import * as configs from "../config"
import * as ua from "../utils/ua"
import * as url from "../utils/url"
import * as aes from "../utils/aes"
import * as md5 from "../libs/md5"

export function getQQNickname(params) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    params = helper.extend(
      {
        cmd: 1,
        pf: "mds_wechat_qb-pay_html5-html5",
        pfkey: "pfkey",
        from_h5: 1,
        from_https: 1
      },
      params
    )

    request
      .ajax({
        url: "//" + env + "api.unipay.qq.com/v1/r/" + params.offerId + "/wechat_query",
        data: params
      })
      .then(
        res => {
          if (res.ret == 0) {
            resolve(decodeURIComponent(res.nick))
          } else {
            reject(res)
          }
        },
        () => {
          reject({
            msg: "timeout"
          })
        }
      )
  })
}

export function getWechatBindQQ(params) {
  return new Promise((resolve, reject) => {
    let env = ""
    if (params.sandbox == 1) {
      env = "sandbox."
    } else if (params.sandbox == 2) {
      env = "dev."
    }
    params = helper.extend(
      params,
      {
        friends: 0,
        pf: "mds_wechat_qb-pay_html5-html5",
        pfkey: "pfkey",
        from_https: 1,
        from_h5: 1
      },
      aes.encrypt(params, ["openid", "openkey", "session_id", "session_type"], params.sandbox)
    )

    request
      .ajax({
        url: "//" + env + "api.unipay.qq.com/v1/r/" + params.offerId + "/ygejcv0sgl",
        data: params
      })
      .then(
        res => {
          if (res.ret == 0) {
            resolve(res.qquin)
          } else {
            reject(res)
          }
        },
        () => {
          reject({
            msg: "timeout"
          })
        }
      )
  })
}

/* global mqq */
export function shareMessageInQQ(params) {
  initMqq().then(() => {
    let data = {
      share_type: params.type || 0,
      title: params.title,
      desc: params.desc,
      share_url:
        params.url || `${location.origin}${location.pathname}${url.delParam("pf", location.search)}&pf=${params.pf}${location.hash}`,
      image_url: params.img,
      back: true
    }
    if (mqq.compare("5.4") != 0) {
      //5.4不能增加公众号显示，会导致程序crash
      data.puin = "3042703080"
      data.sourceName = "腾讯充值"
    }
    mqq.ui.shareMessage(data, result => {
      params.reportCallback && params.reportCallback(result)
    })
  })
}

export function showShareMenu() {
  initMqq().then(() => {
    mqq.ui.showShareMenu()
  })
}

function initMqq() {
  return request.getScript(configs.MQQ_URL)
}

export function setOnMqqShareHandler(params) {
  initMqq().then(() => {
    mqq.ui.setOnShareHandler(type => {
      params.type = type
      shareMessageInQQ(params)
    })
  })
}

export function initWechatJSBridge() {
  return new Promise(resolve => {
    if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
      resolve()
    } else {
      if (document.addEventListener) {
        document.addEventListener("WeixinJSBridgeReady", resolve, false)
      } else if (document.attachEvent) {
        document.attachEvent("WeixinJSBridgeReady", resolve)
        document.attachEvent("onWeixinJSBridgeReady", resolve)
      }
    }
  })
}

export function setOnWechatShareHandler(params) {
  initWechatJSBridge().then(() => {
    WeixinJSBridge.on("menu:share:appmessage", shareMessageInWechat("sendAppMessage", params)) // 监听发送好友事件
    WeixinJSBridge.on("menu:share:timeline", shareMessageInWechat("shareTimeline", params)) // 监听朋友圈分享事件
    WeixinJSBridge.on("menu:share:qq", shareMessageInWechat("shareQQ", params)) // 监听分享到QQ事件
  })
}

function shareMessageInWechat(type, params) {
  return () => {
    WeixinJSBridge.invoke(
      type,
      {
        appid: params.wxAppid2,
        img_url: params.img,
        img_width: "240",
        img_height: "240",
        link:
          params.url ||
          `${location.origin}${location.pathname}${url.delParam(["pf", "code"], location.search)}&pf=${params.pf}${location.hash}?a=1`,
        desc: params.desc,
        title: params.title
      },
      () => {}
    )
    params.reportCallback && params.reportCallback()
  }
}

export function getZoneInfo(params) {
  return new Promise((resolve, reject) => {
    request
      .getScript(`${configs.GAME_INFO[params.offerId].ZONE_URL}?t=${new Date().getTime()}`)
      .then(() => {
        resolve(window[configs.GAME_INFO[params.offerId].ZONE_KEY].STD_DATA)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export function getRoleInfo(params) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let urlParams = {
      from_https: 1,
      from_h5: 1,
      pf: `mds_wechat_qb-pay_html5-${params.clientVersion}`,
      pfkey: "pfkey",
      cmd: 15,
      openid: params.openid,
      openkey: params.openkey,
      session_id: params.sessionId,
      session_type: params.sessionType,
      wx_appid: params.wxAppid2,
      partition: params.zoneid,
      game_platform_id: params.platformId,
      area: params.area
    }

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/wechat_query`,
        data: urlParams
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function getUserRecommend(params) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let urlParams = {
      from_https: 1,
      from_h5: 1,
      pf: "mds_wechat_qb-pay_html5-html5",
      pfkey: "pfkey",
      cmd: 26,
      openid: params.openid,
      openkey: params.openkey,
      session_id: params.sessionId,
      session_type: params.sessionType,
      model: params.model,
      ext: `usr_appid=${params.ext}`
    }

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/wechat_query`,
        data: urlParams
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function getPCGameRoleInfo(params) {
  return new Promise((resolve, reject) => {
    let urlParams = {
      from_https: 1,
      from_h5: 1,
      pf: "mds_wechat_qb-pay_html5-html5",
      pfkey: "pfkey",
      openid: params.openid,
      openkey: params.openkey,
      session_id: params.sessionId,
      session_type: params.sessionType,
      // wx_appid: params.wxAppid2,
      sck: md5.hex_md5(params.offerId + params.openkey),
      game_info_mode: 1,
      change_wx_openid: 1,
      zoneid: params.zoneid,
      isusempaymode: 1,
      game_scene: "dq_pay",
      t: +new Date()
    }

    urlParams = helper.extend(urlParams, aes.encrypt(urlParams, ["openid", "openkey", "session_id", "session_type"], params.sandbox))
    request
      .ajax({
        url: `//api.unipay.qq.com/v1/r/${params.offerId}/get_role_list`,
        data: urlParams
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
  })
}

export function jumpToMqq(_url) {
  let url = "mqqapi://forward/url?src_type=web&version=1&url_prefix=" + btoa(_url)
  let userAgent = ua.getUserAgent()
  //判断微信6.5.6客户端，这个客户端不允许使用schema跳转跳手Q
  var m = / MicroMessenger\/([0-9\.]+)/i.exec(navigator.userAgent)
  if (m && m[1] && compare(m[1], "6.5.6") >= 0) {
    initWechatJSBridge().then(() => {
      onWxJSBridgeReady(url)
    })
  } else if (userAgent.QQ) {
    location.href = _url
  } else {
    location.href = url
  }
}

function onWxJSBridgeReady(url) {
  WeixinJSBridge.invoke(
    "launchApplication",
    {
      schemeUrl: url
    },
    function(res) {
      //如果没调起的话
      if (res.err_msg !== "launchApplication:ok") {
        if (/Android/.test(navigator.userAgent)) {
          location.href = url
        } else {
          WeixinJSBridge.invoke(
            "launchApplication",
            {
              appID: "mqqapi",
              parameter: url.replace(/^mqqapi:\/\//, "")
            },
            function() {}
          )
        }
      }
    }
  )
}

function compare(curV, reqV) {
  if (curV && reqV) {
    //将两个版本号拆成数字
    var arr1 = curV.split("."),
      arr2 = reqV.split(".")
    var minLength = Math.min(arr1.length, arr2.length),
      position = 0,
      diff = 0
    //依次比较版本号每一位大小，当对比得出结果后跳出循环（后文有简单介绍）
    while (position < minLength && (diff = parseInt(arr1[position]) - parseInt(arr2[position])) == 0) {
      position++
    }
    diff = diff != 0 ? diff : arr1.length - arr2.length
    //若curV大于reqV，则返回true
    return diff
  } else {
    //输入为空
    return -1
  }
}

export function getMobileZones(params) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let urlParams = {
      from_https: 1,
      from_h5: 1,
      pf: `mds_wechat_qb-pay_html5-${params.clientVersion}`,
      pfkey: "pfkey",
      cmd: 14,
      openid: params.openid,
      openkey: params.openkey,
      session_id: params.sessionId,
      session_type: params.sessionType,
      wx_appid: params.wxAppid2,
      use_currency_offerid: 1
    }

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/wechat_query`,
        data: urlParams
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function getMobileRoleInfo(params) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let urlParams = {
      from_https: 1,
      from_h5: 1,
      pf: `mds_wechat_qb-pay_html5-${params.clientVersion}`,
      pfkey: "pfkey",
      cmd: 15,
      openid: params.openid,
      openkey: params.openkey,
      session_id: params.sessionId,
      session_type: params.sessionType,
      wx_appid: params.wxAppid2,
      zoneid: params.zoneid,
      use_currency_offerid: 1
    }

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/wechat_query`,
        data: urlParams
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}
